module.exports = __webpack_public_path__ + "static/yoelsumitro-6756182becedd0a8b620f7db306579f3.jpg";